import XRegExp from 'xregexp';

interface Langs { zh: number, jp: number }

class LanguageHelper {
  private _locale = 'en-GB'

  get locale(): string {
    return this._locale;
  }

  set locale(value: string) {
    this._locale = value;
  }

  detectLanguages(text: string) {
    const splitText = text
      .trim()
      .split(/\s+/);
    const scores = splitText
      .reduce((acc: Langs, word) => {
        const scores = this.detectScores(word);
        acc.zh = (scores.zh + acc.zh) ;
        acc.jp = (scores.jp + acc.jp) ;
        return acc;
      }, {zh: 0, jp: 0});
    scores.zh = scores.zh / splitText.length;
    scores.jp = scores.jp / splitText.length;
    return scores;
  }

  detectScores(text: string) {
    const scores: Langs = {
      jp: 0,
      zh: 0
    };
    const regexes = {
      zh: XRegExp('\\p{Han}', 'gi'),
      jp: XRegExp('[\\p{Hiragana}\\p{Katakana}]', 'gi')
    };
    for (const [lang, regex] of Object.entries(regexes)) {
      let matches = XRegExp.match(text, regex) || [];
      let score = matches.length / text.length;
      if (score) {
        // @ts-ignore
        scores[lang] = (scores[lang] + score);
      }
    }
    return scores;
  }

  isLocaleChineseSimplified() {
    return this.locale === 'zh-CN';
  }

  containsJapaneseChars(str: string) {
    const scores = this.detectLanguages(str);
    return Boolean(scores.jp > 0);
  }

  containsTurkish(str: string) {
    return /[çğıİöşüÇĞÖŞÜ]/.test(str);
  }

  containsDeutch(str: string) {
    return /[äöüÄÖÜßẞ]/.test(str);
  }

  containsPolish(str: string) {
    return /[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/.test(str);
  }

  containsChineseOrJapaneseChars(str: string) {
    return /[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f]/.test(str);
  }

  containsKoreanChars(str: string) {
    return /[\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3]/.test(str);
  }
}

export default new LanguageHelper();
